var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vector',{staticClass:"svg-bg",style:({ backgroundColor: _vm.baseColor, fill: _vm.fillColor }),attrs:{"src":_vm.bgImage}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a347848","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/StageBackground.vue
// module id = null
// module chunks = 